import { render } from "./Asset_register_report.vue?vue&type=template&id=45f84cbb&scoped=true"
import script from "./Asset_register_report.vue?vue&type=script&lang=js"
export * from "./Asset_register_report.vue?vue&type=script&lang=js"

import "./Asset_register_report.vue?vue&type=style&index=0&id=45f84cbb&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f84cbb"]])

export default __exports__